import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { AssignTripsComponent } from './assign-trips.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssignTripsCanDeactivateGuard implements CanDeactivate<AssignTripsComponent> {
  canDeactivate(
    component: AssignTripsComponent
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (component.allowNavigation) {
      component.allowNavigation = false; // Reset for next time
      return true;
    }
    if (component.showNavigationModal) return false;
    return new Promise<boolean>(resolve => {
      component.showNavigationModal = true;
      component.resolveNavigation = (result: boolean) => {
        resolve(result);
        component.resolveNavigation = null;
        component.allowNavigation = false; // Always reset
      };
    });
  }
} 